import { RegularButton, Modal } from 'fronton-react'
import { FC } from "react";
import './modalClasses.scss'


export interface EmptyFieldsModalProps {
    open: boolean,
    onClose: () => void,
    onSave: () => void,
    text: string,
    isError: boolean,
}

export const EmptyFieldsModal: FC<EmptyFieldsModalProps> = ({open, onClose, onSave, text, isError}) => {
    return (
        <Modal
        size="s"
        className="add-calendar-modal"
        show={open}
        closeButton={false}
        onClose={onClose}
        overlayType="medium"
    >
        <div className="modal-content">
            <div className="modal-content-body">{text}</div>
            <div className="modal-content-actions">
                {isError ? (
                    <RegularButton
                        key="submit"
                        size="s"
                        variant="primary"
                        className="modal-content-btn"
                        onClick={onClose}
                    >
                        OK
                    </RegularButton>
                ) : (
                    <>
                        <RegularButton
                            key="submit"
                            size="s"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={() => {
                                onClose()
                                onSave()
                            }}
                        >
                            Да
                        </RegularButton>
                        <RegularButton
                            key=""
                            size="s"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={onClose}
                        >
                            Нет
                        </RegularButton>
                    </>
                )}
            </div>
        </div>
    </Modal>

    )
}